export default "__VITE_ASSET__CGnB72kX__"